import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import { AlertTriangle, Calendar, CalendarClock, UserRound, Workflow } from 'lucide-react'
import { useState } from 'react'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { useStyles } from './style'

const ExistingTicketDialog = ({
  open,
  onClose,
  existingTicket,
  onRequestTransfer,
  onAcceptTicket,
  onOpenTicket
}) => {
  const classes = useStyles()
  const [transferring, setTransferring] = useState(false)

  // Verificação de segurança para o ticket
  if (!existingTicket) {
    return null
  }

  const isUnassigned = !existingTicket?.user || !existingTicket.user.id

  const handleRequestTransfer = async () => {
    setTransferring(true)
    try {
      if (isUnassigned) {
        await onAcceptTicket(existingTicket.id)
      } else {
        await onRequestTransfer(existingTicket.id)
      }
    } finally {
      setTransferring(false)
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Data não disponível'
    return new Date(dateString).toLocaleString('pt-BR')
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'open':
        return '#4CAF50'
      case 'pending':
        return '#FF9800'
      case 'closed':
        return '#9E9E9E'
      default:
        return '#2196F3'
    }
  }

  const getStatusText = (status) => {
    switch (status) {
      case 'open':
        return 'Aberto'
      case 'pending':
        return 'Pendente'
      case 'closed':
        return 'Fechado'
      default:
        return status || 'Status não definido'
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box className={classes.titleBox}>
          <Typography variant="h6" component="span">
            Informação do Atendimento
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers className={classes.dialogContent}>
        <Box className={classes.warningBox}>
          <Typography variant="body1" className={classes.warningText}>
            <AlertTriangle size={22} />
            Existe atendimento aberto para este contato
          </Typography>
        </Box>

        <Box className={classes.ticketInfo}>
          <Box className={classes.ticketHeader}>
            <Typography variant="h6" className={classes.contactName}>
              {existingTicket?.contact?.name || 'Contato não identificado'}
            </Typography>
            <Chip
              label={getStatusText(existingTicket?.status)}
              style={{
                backgroundColor: getStatusColor(existingTicket?.status),
                color: 'white',
                fontWeight: 'bold'
              }}
              size="small"
            />
          </Box>

          <Box className={classes.ticketDetails}>
            <Box className={classes.detailItem}>
              <UserRound size={16} />
              <Typography variant="body2">
                <strong>Atendente:</strong>{' '}
                {existingTicket?.user?.name || 'Não atribuído'}
              </Typography>
            </Box>

            <Box className={classes.detailItem}>
              <Workflow size={16} />
              <Typography variant="body2">
                <strong>Departamento:</strong>{' '}
                {existingTicket?.queue?.name || 'Não definido'}
              </Typography>
            </Box>

            <Box className={classes.detailItem}>
              <Calendar size={16} />
              <Typography variant="body2">
                <strong>Criado em: </strong>
                {formatDate(existingTicket?.createdAt)}
              </Typography>
            </Box>

            <Box className={classes.detailItem}>
              <CalendarClock size={16} />
              <Typography variant="body2">
                <strong>Atualizado em:</strong>
                {formatDate(existingTicket?.updatedAt)}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Typography variant="body2" className={classes.instructionText}>
          {isUnassigned
            ? 'Este atendimento ainda não possui atendente. Você pode transferi-lo para você.'
            : 'Você pode solicitar a transferência para você.'}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <ButtonSecondary
          onClick={onClose}
          label="Cancelar"
          disabled={transferring}
        />

        {/* <ButtonSecondary
          onClick={() => onOpenTicket(existingTicket)}
          label="Abrir Atendimento"
          disabled={transferring}
        /> */}

        <ButtonPrimary
          onClick={handleRequestTransfer}
          label={
            transferring
              ? 'Solicitando...'
              : isUnassigned
                ? 'Transferir para mim'
                : 'Solicitar Transferência'
          }
          disabled={transferring}
        />
      </DialogActions>
    </Dialog>
  )
}

export default ExistingTicketDialog
